export const EditReferences = {
  EditReferences: {
    path: '/editReferences/:sourceCabinetId/:sourceDocumentTypeId/:sourceDocumentId',
    name: 'editReferences'
  },
  Base: {
    path: '/editReferences',
    name: 'EditReferences'
  }
};
